import React, { Component } from 'react'
import Context from './Context'
import { TELEGRAM_THEME_VARS, mergeClasses } from './telegramTheme'
import './vendor/telegram-ui.css'
import './TelegramButton.css'

const MODE_CLASS = {
  filled: 'tgui-8a1ca9efa24f4809',
  bezeled: 'tgui-91bda9a36246a33c',
  plain: 'tgui-48956537c34690db',
  gray: 'tgui-93106efd6b6d66ee',
  outline: 'tgui-e884e36ff1faa596',
  white: 'tgui-ba6d30cc81e39ae5'
}

const SIZE_CLASS = {
  s: 'tgui-13f23a224303ddaa',
  m: 'tgui-1a16a49d89076ff4',
  l: 'tgui-9cef742a22f195c9'
}

class TelegramButton extends Component {
  static contextType = Context

  render () {
    const theme = this.context && this.context.theme === 'dark' ? 'dark' : 'light'

    const {
      mode = 'filled',
      size = 'm',
      platform = 'base',
      stretched = false,
      loading = false,
      disabled = false,
      bare = false,
      description,
      containerWidth,
      before,
      after,
      children,
      onClick,
    } = this.props

    const buttonClassName = mergeClasses([
      'tgui-b5d680db78c4cc2e',
      'tgui-117e77cd385a9c8d',
      MODE_CLASS[mode] || MODE_CLASS.filled,
      SIZE_CLASS[size] || SIZE_CLASS.m,
      platform === 'ios' ? 'tgui-55e8aa7f5cea2280' : null,
      stretched ? 'tgui-726846958fe7f4a0' : null,
      loading ? 'tgui-490cb0f5ec4998f3' : null,
    ])

    const wrapperClassName = mergeClasses([
      'TelegramButtonDemo',
      theme === 'dark' ? 'TelegramButtonDemo--dark' : 'TelegramButtonDemo--light'
    ])

    const hintClassName = mergeClasses([
      'TelegramButtonHint',
      theme === 'dark' ? 'TelegramButtonHint--dark' : null,
    ])

    const buttonNode = (
      <button
        type='button'
        className={ buttonClassName }
        onClick={ onClick }
        disabled={ disabled || loading }
      >
        { loading &&
          <span className='tgui-014f2b7d196b090d'>
            <span className='TelegramButtonSpinner'></span>
          </span>
        }

        { before &&
          <span className='tgui-06cc94d03a7c4dd7'>{ before }</span>
        }

        <span className='tgui-5f6014c0f063b6de'>
          { children || 'Button' }
        </span>

        { after &&
          <span className='tgui-8310172a5320ab71'>{ after }</span>
        }
      </button>
    )

    if (bare) {
      return buttonNode
    }

    return (
      <div
        className={ wrapperClassName }
        style={{
          ...TELEGRAM_THEME_VARS[theme],
          width: stretched ? (containerWidth || 300) : undefined,
        }}
      >
        { buttonNode }

        { description &&
          <div className={ hintClassName }>{ description }</div>
        }
      </div>
    )
  }
}

export default TelegramButton
